import i18n from '@/i18n';

const listTypeFilters = [
    { value: 1, label: i18n.t('filter.allFilter') },
    { value: 2, label: i18n.t('filter.anyFilter') }
];

const listTypeText = [
    { value: '=', label: i18n.t('filter.condition1') },
    { value: '!=', label: i18n.t('filter.condition2') },
    { value: 'in', label: i18n.t('filter.condition3') },
    { value: 'not in', label: i18n.t('filter.condition4') },
    { value: 'like', label: i18n.t('filter.condition5') },
    { value: 'not like', label: i18n.t('filter.condition6') }
];

const listTypeTextArea = [
    { value: 'like', label: i18n.t('filter.condition5') },
    { value: 'not like', label: i18n.t('filter.condition6') }
];

const listTypeSelect = [
    { value: 'in', label: i18n.t('filter.condition3') },
    { value: 'not in', label: i18n.t('filter.condition4') }
];

const listTypeNumber = [
    { value: '=', label: i18n.t('filter.condition1') },
    { value: '!=', label: i18n.t('filter.condition2') },
    { value: '<', label: i18n.t('filter.condition8') },
    { value: '>', label: i18n.t('filter.condition10') },
    { value: '>=', label: i18n.t('filter.condition9') },
    { value: '<=', label: i18n.t('filter.condition7') },
    { value: 'in', label: i18n.t('filter.condition3') },
    { value: 'not in', label: i18n.t('filter.condition4') }
];

const listTypeDate = [
    { value: '=', label: i18n.t('filter.condition1') },
    { value: '!=', label: i18n.t('filter.condition2') },
    { value: '<=', label: i18n.t('filter.condition7') },
    { value: '<', label: i18n.t('filter.condition8') },
    { value: '>=', label: i18n.t('filter.condition9') },
    { value: '>', label: i18n.t('filter.condition10') }
];

const listMultiLineText = [
    { value: 'in', label: i18n.t('filter.condition3') },
    { value: 'not in', label: i18n.t('filter.condition4') }
];

const listTypeLink = [
    { value: '=', label: i18n.t('filter.condition1') },
    { value: '!=', label: i18n.t('filter.condition2') },
    { value: 'in', label: i18n.t('filter.condition3') },
    { value: 'not in', label: i18n.t('filter.condition4') },
    { value: 'like', label: i18n.t('filter.condition5') },
    { value: 'not like', label: i18n.t('filter.condition6') }
];

export { listTypeFilters, listTypeText, listTypeTextArea, listTypeSelect, listTypeNumber, listTypeDate, listMultiLineText, listTypeLink };
